// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"breadcrumb-item_link-wrapper__qKuup","link":"breadcrumb-item_link__PrXkJ","last-link":"breadcrumb-item_last-link__jLgkf","arrow":"breadcrumb-item_arrow__kVcod"};